<template>
  <div v-show="menuOpen" class="absolute left-0 z-50 h-page-mobile min-w-full overflow-y-auto bg-white">
    <h2 class="mx-6 mb-2 mt-6 text-2xl font-medium">{{ t('ikke3Z8xpqAidzDFLQtdD') }}</h2>
    <div class="mx-6 mb-4 mt-6 flex flex-col gap-4">
      <div v-for="appRoute in hamburgerMenuRoutes" :key="appRoute.title">
        <ui-header-hamburger-menu-nav-item :route="appRoute" @click="menuOpen = !menuOpen" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouteConfig } from '@/common';
import { BREAKPOINTS_INT } from '@/constants';
import { currentLocaleName } from '@/locales';
import { useWindowSize } from '@vueuse/core';
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { width } = useWindowSize();

watch(
  () => width.value,
  () => {
    if (width.value > BREAKPOINTS_INT.md) {
      menuOpen.value = false;
    }
  }
);

const menuOpen = defineModel<boolean>();

const hamburgerMenuRoutes = computed(() => {
  return [
    {
      title: t('3ZkeE9bKQrkO2Rich2ppu'),
      link: '/',
      routeType: 'internal',
    },
    {
      title: t('rteN8e-eLrj-pOfcHJatu'),
      link: 'https://www.manitoba.ca/wildfire',
      routeType: 'external',
    },
    {
      title: t('mnxxi8Gxsh23V1-swUJ4J'),
      link: '/map-icons',
      routeType: 'internal',
    },
    {
      title: t('ik7rCLSe3Hu2tbrECltDA'),
      link: '/map-guide',
      routeType: 'internal',
    },
    {
      title: t('worQ16AQn448N1wCt-tLQ'),
      link: '/text-version',
      routeType: 'internal',
    },
    {
      title: t('1a7LOuqd0nGD2JxQBAq2-'),
      link: '/about',
      routeType: 'internal',
    },
    {
      title: currentLocaleName.value,
      link: '/language',
      routeType: 'internal',
      icon: 'language',
      label: t('aKvqWQSlqiussEn7a1bT5'),
    },
  ] as RouteConfig[];
});
</script>
